import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule }    from '@angular/forms';
import { MatExpansionModule,
         MatButtonModule, 
         MatCheckboxModule} from '@angular/material';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import {MatSidenavModule} from '@angular/material/sidenav';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { KatexModule } from 'ng-katex';

import { AppComponent } from './app.component';
import { MultiplyComponent } from './multiply/multiply.component';
import { DivisionComponent } from './division/division.component';
import { AddComponent } from './add/add.component';
import { SubtractComponent } from './subtract/subtract.component';
import { FractionsComponent } from './fractions/fractions.component';
import { AppRoutingModule } from './app-routing.module';
import { MultiplyCalcComponent } from './multiply/multiply-calc.component';
import { MenuComponent } from './menu/menu.component';
import { CardTemplateComponent } from './card-template/card-template.component';
import { MenuFractionsComponent } from './menu-fractions/menu-fractions.component';
import { MenuMultiplyComponent } from './menu-multiply/menu-multiply.component';
import { MenuProcentComponent } from './menu-procent/menu-procent.component';
import { MenuInactionComponent } from './menu-inaction/menu-inaction.component';
import { FractionsIntroComponent } from './fractions-intro/fractions-intro.component';
import { FractionsExtendComponent } from './fractions-extend/fractions-extend.component';
import { ScoringComponent } from './scoring/scoring.component';
import { LevelsComponent } from './levels/levels.component';
import { FractionsNumbersComponent } from './fractions-numbers/fractions-numbers.component';
import { ExerciseStarterComponent } from './exercise-starter/exercise-starter.component';



@NgModule({
  declarations: [
    AppComponent,
    MultiplyComponent,
    DivisionComponent,
    AddComponent,
    SubtractComponent,
    FractionsComponent,
    MultiplyCalcComponent,
    MenuComponent,
    CardTemplateComponent,
    MenuFractionsComponent,
    MenuMultiplyComponent,
    MenuProcentComponent,
    MenuInactionComponent,
    FractionsIntroComponent,
    FractionsExtendComponent,
    ScoringComponent,
    LevelsComponent,
    FractionsNumbersComponent,
    ExerciseStarterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    MatButtonModule, 
    MatCheckboxModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatGridListModule,
    MatCardModule,
    MatTabsModule,
    MatExpansionModule,
    MatSidenavModule,
    ReactiveFormsModule,
    KatexModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/app.module.ts